import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Button, Utils, GridRow, GridColumn } from "arv-reactcomponents";
import { PAYMENTPAGE, Endpoints } from "npmlinks-constants";
import SavedCardCvv from "./SavedCardCvv";
import { validCvvLength } from "../../../utils";

class SavedCardView extends PureComponent {
  constructor() {
    super();
    this.getImageURL = this.getImageURL.bind(this);
  }

  getImageURL = bankCode => {
    let imageURL = "";
    switch (bankCode) {
      case "VISA":
        imageURL = Endpoints.VISA_CARD;
        break;
      case "MAST":
        imageURL = Endpoints.MASTER_CARD;
        break;
      case "AMEX":
        imageURL = Endpoints.AMEX_CARD;
        break;
      default:
        imageURL = "";
    }
    return imageURL;
  };

  render() {
    const {
      cardMorphedNumber,
      expMonth,
      expYear,
      cardType,
      cardname,
      cardToken,
      bankCode = "",
      isModal,
      selectedSavedCard,
      handleSubmit,
      onFocus,
    } = this.props;
    const cardExpiryYear = expYear && expYear.substr(2);

    return (
      <GridRow>
        <GridColumn className="nw-savedcardview-details">
          {/* use bankcode to decide on cardtypeimage */}
          <GridRow>
            <GridColumn>
              <img
                className={`nw-savedcardview-${bankCode.toLowerCase()}`}
                src={this.getImageURL(bankCode)}
                alt="cardtype"
              />
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn className="nw-savedcardview-cardmargin">
              {cardMorphedNumber}
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn className="nwc-grid-col-xs-8 nw-savedcardview-validcol">
              <div className="nw-savedcardview-validity">
                <span className="nw-savedcardview-validthroughtext">
                  {PAYMENTPAGE.SAVEDCARDVIEW_VALIDTHROUGH}
                </span>
                <span>
                  {expMonth}/{cardExpiryYear}
                </span>
              </div>
            </GridColumn>
            <GridColumn className="nwc-grid-col-xs-4">
              {isModal ? (
                <Button
                  className="nwc-btn nwc-btn-primary nwc-btn-xs nw-savedcardview-button"
                  onClick={() => {
                    selectedSavedCard(this.props);
                  }}
                >
                  {PAYMENTPAGE.SAVEDCARDVIEW_SELECT_BTN_TEXT}
                </Button>
              ) : (
                <SavedCardCvv.component
                  validCvvLength={validCvvLength(cardType)}
                  handleSubmit={cardCvv => handleSubmit(cardCvv)}
                  cvvErrorMessage={
                    PAYMENTPAGE.CARD_VALIDATION_MESSAGES.CVV_MISSING
                  }
                  passedId={cardToken}
                  onFocus={onFocus}
                  isSavedCardSelected={this.props.isSavedCardSelected}
                  optionDisabled={this.props.optionDisabled}
                />
              )}
            </GridColumn>
          </GridRow>
        </GridColumn>
      </GridRow>
    );
  }
}

SavedCardView.defaultProps = {
  selectedSavedCard: Utils.noop,
  handleSubmit: Utils.noop,
  onFocus: Utils.noop,
  isSavedCardSelected: false,
  optionDisabled: false,
};

SavedCardView.propTypes = {
  cardMorphedNumber: PropTypes.string.isRequired,
  expMonth: PropTypes.string.isRequired,
  expYear: PropTypes.string.isRequired,
  cardType: PropTypes.string.isRequired,
  cardname: PropTypes.string.isRequired,
  cardToken: PropTypes.string.isRequired,
  bankCode: PropTypes.string.isRequired,
  isModal: PropTypes.bool.isRequired,
  selectedSavedCard: PropTypes.func,
  handleSubmit: PropTypes.func,
  onFocus: PropTypes.func,
  isSavedCardSelected: PropTypes.bool,
  optionDisabled: PropTypes.bool,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: SavedCardView,
  component: SavedCardView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentSavedCard/SavedCardView/index.js